// Class names for the correct/with mistakes/incorrect glyphs.
export default Object.freeze({
  CORRECT: 'glyph glyph-correct-result',
  CORRECT_WITH_MISTAKES: 'glyph glyph-correct-with-mistakes-result',
  INCORRECT: 'glyph glyph-incorrect-result',
});
